import { utils } from '@sfaas/util';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPlants: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getScreenUsageHistory: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		queryStr = utils.$sf_objectToQueryString({
			searchMonth: searchParams.searchMonth,
			//	searchUserId: searchParams.searchUserId,
			//	searchUserNm: searchParams.searchUserNm,
			currentPage,
			pageUnit
		});
		//let url = `${BASE_URL}/summary/v1/users` + queryStr;
		let url = `${BASE_URL}/summary/v1/menu` + queryStr;
		// console.log('url :' + url);
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
